import { AbstractIconComponent } from '../abstract.icon'
import { Component } from '@angular/core'

@Component({
  selector: 'icon-ev-connector-nema-515',
  templateUrl: './ev-connector-nema515.icon.html',
})
export class EvConnectorNema515IconComponent extends AbstractIconComponent {
  static icon = 'ev-connector-nema-515'
}
